// New Zealand Regions
export const NZ_REGIONS = [
  'Northland',
  'Auckland',
  'Waikato',
  'Bay of Plenty',
  'Gisborne',
  'Hawkes Bay',
  'Taranaki',
  'Manawatu-Whanganui',
  'Wellington',
  'Tasman',
  'Nelson',
  'Marlborough',
  'West Coast',
  'Canterbury',
  'Otago',
  'Southland',
] as const

export type NZRegion = typeof NZ_REGIONS[number]

// Admin emails
export const ADMIN_EMAILS = [
  'admin@isqroll.co.nz',
  'joel@temperocreative.co.nz',
  'demo@isqroll.co.nz',
]

// Demo credentials
export const DEMO_CREDENTIALS = {
  email: 'demo@isqroll.co.nz',
  password: 'demo123',
}

// Canonical URL used for Firebase Auth action redirects (password reset,
// email verification continueUrl). Hardcoded so Firebase Auth always sees
// an authorized domain — see CLAUDE.md "DNS cutover" task: flip to
// https://isqroll.co.nz/ once the custom domain is live.
export const POST_AUTH_RETURN_URL = 'https://isqroll-7f137.web.app/'
